import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
import React from "react";
export type BenefitListItemViewProps = {
  text?: React.ReactNode;
  title?: string | null;
};
export function BenefitListItemView({
  text,
  title
}: BenefitListItemViewProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  return <_StyledDiv $_css={[{
    "display": "flex",
    "height": "100%",
    "flexDirection": "column",
    "borderRadius": "4px",
    "backgroundColor": "var(--bg-tertiary)",
    "paddingLeft": "var(--spacing-md)",
    "paddingRight": "var(--spacing-md)",
    "paddingTop": "var(--spacing-lg)",
    "paddingBottom": "var(--spacing-lg)",
    "color": "var(--text-primary)",
    "@media (min-width: 1024px)": {
      "padding": "4rem"
    }
  }]}>
      <_StyledButton onClick={() => setIsOpen(prev => !prev)} aria-expanded={isOpen} $_css2={[{
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "gap": "0.8rem",
      "textAlign": "left",
      "@media (min-width: 1024px)": {
        "pointerEvents": "none",
        "cursor": "default"
      }
    }]}>
        <_StyledH>{title}</_StyledH>
        <_StyledSpan $_css3={[{
        "position": "relative",
        "height": "1rem",
        "width": "1rem",
        "flexShrink": "0",
        "@media (min-width: 1024px)": {
          "display": "none"
        }
      }]}>
          <_StyledSpan2 $_css4={[{
          "position": "absolute",
          "left": "50%",
          "top": "50%",
          "height": "1px",
          "width": "100%",
          "--tw-translate-x": "-50%",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "--tw-translate-y": "-50%",
          "backgroundColor": "currentColor"
        }]} />
          <_StyledSpan3 $_css5={[{
          "position": "absolute",
          "left": "50%",
          "top": "50%",
          "height": "1px",
          "width": "100%",
          "--tw-translate-x": "-50%",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
          "--tw-translate-y": "-50%",
          "backgroundColor": "currentColor",
          "transitionProperty": "transform",
          "transitionDuration": "250ms",
          "transitionTimingFunction": "ease-in-out"
        }, !isOpen && {
          "--tw-rotate": "90deg",
          "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
        }]} />
        </_StyledSpan>
      </_StyledButton>
      {text && <_StyledDiv2 $_css6={[{
      "display": "grid",
      "transitionProperty": "grid-template-rows",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out"
    }, isOpen ? {
      "gridTemplateRows": "1fr"
    } : {
      "gridTemplateRows": "0fr"
    }, {
      "@media (min-width: 1024px)": {
        "gridTemplateRows": "1fr"
      }
    }]}>
          <_StyledDiv3>{text}</_StyledDiv3>
        </_StyledDiv2>}
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1hj8l5t-0"
})`${p => p.$_css}`;
var _StyledButton = _styled2("button").withConfig({
  componentId: "sc-sf-1hj8l5t-1"
})`${p => p.$_css2}`;
var _StyledH = _styled3("h3").withConfig({
  componentId: "sc-sf-1hj8l5t-2"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledSpan = _styled4("span").withConfig({
  componentId: "sc-sf-1hj8l5t-3"
})`${p => p.$_css3}`;
var _StyledSpan2 = _styled5("span").withConfig({
  componentId: "sc-sf-1hj8l5t-4"
})`${p => p.$_css4}`;
var _StyledSpan3 = _styled6("span").withConfig({
  componentId: "sc-sf-1hj8l5t-5"
})`${p => p.$_css5}`;
var _StyledDiv2 = _styled7("div").withConfig({
  componentId: "sc-sf-1hj8l5t-6"
})`${p => p.$_css6}`;
var _StyledDiv3 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "benefit-list-item___StyledDiv3",
  componentId: "sc-1mux7p1-0"
})({
  "overflow": "hidden",
  "@media (min-width: 1024px)": {
    "overflow": "visible"
  }
});